const icon = fillColor => ({
  path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z',
  fillColor,
  fillOpacity: 1,
  scale: 1.5,
  scaledSize: { width: 30, height: 30 },
  anchor: { x: 15, y: 15 },
  strokeColor: 'black',
  strokeOpacity: 0.4,
  strokeWeight: 1.5,
});

// color icon
const invalidColor = '#e74c3c';
const validColor = '#27ae60';
const noDataColor = '#e67e22';

// color brand
const brandColor = '#b6543f';

export {
  validColor,
  invalidColor,
  noDataColor,
  icon,
  brandColor,
};




// WEBPACK FOOTER //
// src/utils/styleConst.js